export default {
  lang: 'fy',
  dir: 'ltr',
  common: {
    ok: 'Ok',
    cancel: 'Ôfbrekke',
    key_backspace: 'backspace',
    key_del: 'delete',
    key_down: 'omleech',
    key_up: 'omheech',
    more_opts: 'More Options',
    url: 'URL',
    width: 'Width',
    height: 'Height'
  },
  misc: {
    powered_by: 'Powered by'
  },
  ui: {
    toggle_stroke_tools: 'Show/hide more stroke tools',
    palette_info: 'Klik om de folkleur te feroarjen, shift-klik om de linekleur te feroarjen.',
    zoom_level: 'Yn-/útzoome',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Identify the element',
    fill_color: 'Folkleur oanpasse',
    stroke_color: 'Linekleur oanpasse',
    stroke_style: 'Linestijl oanpasse',
    stroke_width: 'Linebreedte oanpasse',
    pos_x: 'X-koördinaat oanpasse',
    pos_y: 'Y-koördinaat oanpasse',
    linecap_butt: 'Linecap: Butt',
    linecap_round: 'Linecap: Round',
    linecap_square: 'Linecap: Square',
    linejoin_bevel: 'Linejoin: Bevel',
    linejoin_miter: 'Linejoin: Miter',
    linejoin_round: 'Linejoin: Round',
    angle: 'Draaie',
    blur: 'Change gaussian blur value',
    opacity: 'Trochsichtigens oanpasse',
    circle_cx: "Feroarje it X-koördinaat fan it middelpunt fan'e sirkel.",
    circle_cy: "Feroarje it Y-koördinaat fan it middelpunt fan'e sirkel.",
    circle_r: 'Feroarje sirkelradius',
    ellipse_cx: "Feroarje it X-koördinaat fan it middelpunt fan'e ellips.",
    ellipse_cy: "Feroarje it Y-koördinaat fan it middelpunt fan'e ellips.",
    ellipse_rx: 'Feroarje ellips X radius',
    ellipse_ry: 'Feroarje ellips Y radius',
    line_x1: "Feroarje start X koördinaat fan'e line",
    line_x2: "Feroarje ein X koördinaat fan'e line",
    line_y1: "Feroarje start Y koördinaat fan'e line",
    line_y2: "Feroarje ein Y koördinaat fan'e line",
    rect_height: 'Hichte rjochthoeke oanpasse',
    rect_width: 'Breedte rjochthoeke oanpasse',
    corner_radius: 'Hoekeradius oanpasse',
    image_width: 'Breedte ôfbielding oanpasse',
    image_height: 'Hichte ôfbielding oanpasse',
    image_url: 'URL oanpasse',
    node_x: 'X-koördinaat knooppunt oanpasse',
    node_y: 'Y-koördinaat knooppunt oanpasse',
    seg_type: 'Segmenttype oanpasse',
    straight_segments: 'Rjocht',
    curve_segments: 'Bûcht',
    text_contents: 'Tekst oanpasse',
    font_family_label: 'Font:',
    font_family: 'Lettertype oanpasse',
    font_size: 'Lettergrutte oanpasse',
    bold: 'Fet',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'Skean',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Main Menu',
    bkgnd_color_opac: 'Eftergrûnkleur/trochsichtigens oanpasse',
    connector_no_arrow: 'No arrow',
    fitToContent: 'Passe op ynhâld',
    fit_to_all: 'Op alle ynhâld passe',
    fit_to_canvas: 'Op kanvas passe',
    fit_to_layer_content: 'Op laachynhâld passe',
    fit_to_sel: 'Op seleksje passe',
    align_relative_to: 'Útlijne relatyf oan...',
    relativeTo: 'Relatief tsjinoer:',
    page: 'Side',
    largest_object: 'Grutste ûnderdiel',
    selected_objects: 'Selektearre ûnderdielen',
    smallest_object: 'Lytste ûnderdiel',
    new_doc: 'Nije ôfbielding',
    open_doc: 'Ôfbielding iepenje',
    export_img: 'Export',
    save_doc: 'Ôfbielding bewarje',
    import_doc: 'Import SVG',
    align_to_page: 'Align Element to Page',
    align_bottom: 'Ûnder útlijne',
    align_center: 'Midden útlijne',
    align_left: 'Lofts útlijne',
    align_middle: 'Midden útlijne',
    align_right: 'Rjochts útlijne',
    align_top: 'Boppe útlijne',
    mode_select: 'Selektearje',
    mode_fhpath: 'Potlead',
    mode_line: 'Line',
    mode_rect: 'Rectangle Tool',
    mode_square: 'Square Tool',
    mode_fhrect: 'Frije rjochthoeke',
    mode_ellipse: 'Ellips',
    mode_circle: 'Sirkel',
    mode_fhellipse: 'Frije ellips',
    mode_path: 'Paad',
    mode_text: 'Tekst',
    mode_image: 'Ôfbielding',
    mode_zoom: 'Zoom',
    no_embed: 'NOTE: This image cannot be embedded. It will depend on this path to be displayed',
    undo: 'Ungedien meitjse',
    redo: "Op 'e nij",
    tool_source: 'Boarne oanpasse',
    wireframe_mode: 'Triemodel',
    clone: 'Clone Element(s)',
    del: 'Delete Element(s)',
    group_elements: 'Ûnderdielen groepearje',
    make_link: 'Make (hyper)link',
    set_link_url: 'Set link URL (leave empty to remove)',
    to_path: 'Omsette nei paad',
    reorient_path: 'Paad opnij orientearje',
    ungroup: 'Groepering opheffe',
    docprops: 'Dokuminteigenskippen',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Nei eftergrûn',
    move_top: 'Nei foargrûn',
    node_clone: 'Knooppunt duplisearje',
    node_delete: 'Knooppunt fuortsmite',
    node_link: 'Knooppunten keppelje',
    add_subpath: 'Add sub-path',
    openclose_path: 'Open/close sub-path',
    source_save: 'Feroarings tapasse',
    cut: 'Cut',
    copy: 'Copy',
    paste: 'Paste',
    paste_in_place: 'Paste in Place',
    delete: 'Delete',
    group: 'Group',
    move_front: 'Bring to Front',
    move_up: 'Bring Forward',
    move_down: 'Send Backward',
    move_back: 'Send to Back',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'Laach',
    layers: 'Layers',
    del: 'Laach fuortsmite',
    move_down: 'Laach omleech bringe',
    new: 'Nije laach',
    rename: 'Laach omneame',
    move_up: 'Laach omheech bringe',
    dupe: 'Duplicate Layer',
    merge_down: 'Merge Down',
    merge_all: 'Merge All',
    move_elems_to: 'Ûnderdielen ferplaate nei:',
    move_selected: 'Selektearre ûnderdielen ferplaatse nei in oare laach'
  },
  config: {
    image_props: 'Ôfbieldingseigenskippen',
    doc_title: 'Titel',
    doc_dims: 'Kanvasgrutte',
    included_images: 'Ynslúten ôfbieldingen',
    image_opt_embed: 'Ynformaasje tafoege (lokale triemen)',
    image_opt_ref: 'Triemreferensje brûke',
    editor_prefs: 'Eigenskippen bewurker',
    language: 'Taal',
    background: 'Eftergrûn bewurker',
    editor_img_url: 'Image URL',
    editor_bg_note: 'Let op: de eftergrûn wurd net mei de ôfbielding bewarre.',
    select_predefined: 'Selektearje:',
    units_and_rulers: 'Units & Rulers',
    show_rulers: 'Show rulers',
    base_unit: 'Base Unit:',
    grid: 'Grid',
    snapping_onoff: 'Snapping on/off',
    snapping_stepsize: 'Snapping Step-Size:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Ferkearde waarde jûn',
    noContentToFitTo: 'Gjin ynhâld om te passen',
    dupeLayerName: 'Der is al in laach mei dy namme!',
    enterUniqueLayerName: 'Type in unyke laachnamme',
    enterNewLayerName: 'Type in nije laachnamme',
    layerHasThatName: 'Laach hat dy namme al',
    QmoveElemsToLayer: "Selektearre ûnderdielen ferplaatse nei '%s'?",
    QwantToClear: 'Ôfbielding leechmeitsje? Dit sil ek de skiednis fuortsmite!',
    QwantToOpen: 'Do you want to open a new file?\nThis will also erase your undo history!',
    QerrorsRevertToSource: 'Der wiene flaters yn de SVG-boarne.\nWeromgean nei foarige SVG-boarne?',
    QignoreSourceChanges: 'Feroarings yn SVG-boarne negeare?',
    featNotSupported: 'Funksje wurdt net ûndersteund',
    enterNewImgURL: 'Jou de nije URL',
    defsFailOnSave: 'NOTE: Due to a bug in your browser, this image may appear wrong (missing gradients or elements). It will however appear correct once actually saved.',
    loadingImage: 'Loading image, please wait...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Also note the following issues: ',
    unsavedChanges: 'There are unsaved changes.',
    enterNewLinkURL: 'Enter the new hyperlink URL',
    errorLoadingSVG: 'Error: Unable to load SVG data',
    URLLoadFail: 'Unable to load from URL',
    retrieving: 'Retrieving \'%s\'...',
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
